import { FormlyFieldConfig } from '@ngx-formly/core';
import {LocationSetType} from '@emm/core/models/location-set-type.model';
import {Option} from '@emm/core/models/option.model';


const placeholder = 'Search for a Location Set Type';

export const locationSetsFilterFieldMap = (locationSetTypes: LocationSetType[]) =>
    [
        {
            key: 'type',
            templateOptions: {
                label: 'Type',
                placeholder,
                options: locationSetTypes.map(
                    (locationSetType) =>
                        ({
                            label: locationSetType.name,
                            value: locationSetType.tag
                        } as Option)
                )
            },
            type: 'select',
            wrappers: ['form-field-filter']
        }
    ] as FormlyFieldConfig[];
